import { ArrowUp } from 'lucide-react'

import { INTERESTS, SITE, SOCIALS } from '../data/site'
import styles from './Footer.module.css'

const YEAR = new Date().getFullYear()

const PROJECT_LINKS = INTERESTS.filter((interest) => interest.href)

export function Footer() {
  return (
    <footer className={styles.footer}>
      <div className={`container ${styles.inner}`}>
        <div className={styles.identity}>
          <p className={styles.name}>{SITE.name}</p>
          <p className={styles.meta}>
            {SITE.role} · {SITE.location}
          </p>
        </div>

        <nav className={styles.links} aria-label="Elsewhere">
          <ul>
            {SOCIALS.map((social) => (
              <li key={social.kind}>
                <a
                  href={social.href}
                  {...(true
                    ? { target: '_blank', rel: 'me noopener' }
                    : {})}
                >
                  {social.label}
                </a>
              </li>
            ))}
            {PROJECT_LINKS.map((project) => (
              <li key={project.title}>
                <a href={project.href} target="_blank" rel="noopener">
                  {project.title}
                </a>
              </li>
            ))}
          </ul>
        </nav>

        <div className={styles.bottom}>
          <p className={styles.copyright}>
            © {YEAR} {SITE.name}.
          </p>
          <a className={styles.top} href="#main" data-no-print>
            Back to top
            <ArrowUp size={14} aria-hidden="true" />
          </a>
        </div>
      </div>
    </footer>
  )
}
